module.exports = __webpack_public_path__ + "static/media/tennis.05488db4.svg";